/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_SlowInputs */

const en_read_along_ai_slow = /** @type {(inputs: Read_Along_Ai_SlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The response is taking longer. Requests have a time limit and automatic fallback.`)
};

const es_read_along_ai_slow = /** @type {(inputs: Read_Along_Ai_SlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La respuesta está tardando más. Las solicitudes tienen un límite de tiempo y un modelo alternativo.`)
};

/**
* | output |
* | --- |
* | "The response is taking longer. Requests have a time limit and automatic fallback." |
*
* @param {Read_Along_Ai_SlowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_slow = /** @type {((inputs?: Read_Along_Ai_SlowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_SlowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_slow(inputs)
	return en_read_along_ai_slow(inputs)
});